import { render, staticRenderFns } from "./ConfirmBtnGroup.vue?vue&type=template&id=420bc7c1&scoped=true"
import script from "./ConfirmBtnGroup.vue?vue&type=script&lang=js"
export * from "./ConfirmBtnGroup.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBtnGroup.vue?vue&type=style&index=0&id=420bc7c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420bc7c1",
  null
  
)

export default component.exports